import { observer } from 'mobx-react';

import { ExpandableProductAccessoriesTranslation } from '../../../../localization/ModuleTranslation';
import ProductAccessories, {
  ProductAccessoriesSkeleton,
} from '../../../../shared/ProductAccessories/ProductAccessories';
import LoadingStatus from '../../../../ui/LoadingStatus/LoadingStatus';
import ExpandableSection from '../ExpandableSection/ExpandableSection';
import css from './ExpandableProductAccessories.css';
import ExpandableProductAccessoriesState from './ExpandableProductAccessoriesState';

interface ExpandableProductAccessoriesProps {
  state: ExpandableProductAccessoriesState;
  translation: ExpandableProductAccessoriesTranslation;
  className?: string;
}

const ExpandableProductAccessories = ({ className, state, translation }: ExpandableProductAccessoriesProps) => {
  if (state.total === 0) {
    return null;
  }

  return (
    <ExpandableSection className={className} heading={translation.heading} onExpandedChange={state.onExpandedChange}>
      {(triggerId) => <AccessoriesContent state={state} translation={translation} triggerId={triggerId} />}
    </ExpandableSection>
  );
};

export default ExpandableProductAccessories;

interface AccessoriesContentProps {
  state: ExpandableProductAccessoriesState;
  translation: ExpandableProductAccessoriesTranslation;
  triggerId: string;
}

const AccessoriesContent = observer(({ state, translation, triggerId }: AccessoriesContentProps) => {
  if (state.loadingStatus === 'pending') {
    return (
      <>
        <LoadingStatus message={translation.loadingLabel} />
        <ProductAccessoriesSkeleton
          className={css.items}
          rowCount={state.total}
          labelledBy={triggerId}
          translation={translation.table}
        />
      </>
    );
  }

  return (
    <ProductAccessories
      className={css.items}
      accessories={state.items}
      labelledBy={triggerId}
      translation={translation.table}
    />
  );
});
